import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PraticaProgressService } from '../_core/services/pratica-progress.service';
import { PraticaSection } from '../pratica/models/pratica-section';
import {
  Subscription,
  catchError,
  combineLatest,
  forkJoin,
  map,
  mergeMap,
  of,
  startWith,
  switchMap,
  tap,
  timer,
} from 'rxjs';
import { CmsService } from '../_core/services/cms.service';
import { MappedCmsSectionWithFieldList } from '../_core/models/cms-field';
import { SharedModule } from '../_shared/shared.module';
import { AddressFormComponent } from '../_widgets/address-form/address-form.component';
import { SagittaScoreSection } from '../sagitta-score/models/sagitta-score-section';
import { SagittaScoreRow } from '../sagitta-score/models/sagitta-score-row';
import { SagittaScoreElement } from '../sagitta-score/models/sagitta-score-element';
import { SectionId } from '../sagitta-score/configs/section-id-enum';
import { SagittaScore } from '../sagitta-score/models/sagitta-score-model';
import { SagittaScoreArea } from '../sagitta-score/models/sagitta-score-area';
import { MatChipsModule } from '@angular/material/chips';
import { SfSelectFormField, SfUtils, SmartFormComponent } from 'ngx-smart-form';
import { StatoPratica } from '../../interfaces/pratica';
import { AuthService } from '../_core/services/auth.service';
import { ProductService } from '../_core/services/product.service';
import { PersonaGiuridicaService } from '../_core/services/persona-giuridica.service';
import { SagittaScoreFactory } from '../sagitta-score/models/sagitta-score-factory';
import { SagittaScoreDto } from '../sagitta-score/dto/sagitta-score-dto';
import { SagittaScoreAreaDto } from '../sagitta-score/dto/sagitta-score-area-dto';
import { SagittaScoreSectionDto } from '../sagitta-score/dto/sagitta-score-section-dto';
import { LabelPipeModule } from '../_shared/label-pipe/label-pipe.module';
import { GaranteGiuridicoService } from '../_core/services/garante-giuridico.service';
import { AbstractControl } from '@angular/forms';
import { AmlScore } from './aml-score-config/aml-score';
import { AmlScoreService } from '../_core/services/aml-score.service';

@Component({
  selector: 'app-aml-score',
  standalone: true,
  imports: [
    SharedModule,
    AddressFormComponent,
    MatChipsModule,
    LabelPipeModule,
  ],
  templateUrl: './aml-score.component.html',
  styleUrls: ['./aml-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmlScoreComponent implements OnInit {
  @ViewChildren(SmartFormComponent)
  smartFormComponentList?: QueryList<SmartFormComponent>;

  subscription: Subscription;
  //sections: MappedCmsSectionWithFieldList[] = [];

  score?: SagittaScore;

  amlScore?: AmlScore;

  productId = '';
  constructor(
    private praticaProgressService: PraticaProgressService,
    private cdr: ChangeDetectorRef,
    private amlScoreService: AmlScoreService
  ) {
    //this.praticaProgressService.updateProgress(PraticaSection.SCORE, 100);
    this.subscription = this.praticaProgressService.triggerSave$
      /* .pipe(
        mergeMap(() => {
          return this.save();
        })
      ) */
      .subscribe((_) => this.praticaProgressService.notifySectionUpdate());
  }

  ngOnInit(): void {
    let { id, target } = this.praticaProgressService.selectedPratica || {};
    if (!id || !target) return;
    this.amlScoreService
      .getAmlScore(id)

      .subscribe((data) => {
        this.amlScore = data;
        this.praticaProgressService.updateProgress(PraticaSection.SCORE, 100);
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
